import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import Footer from "@/components/Footer";

const About = () => {
  return (
    <>
      <Helmet>
        <title>About - MacroVault</title>
        <meta name="description" content="Learn about MacroVault and our mission to make Excel automation accessible to everyone." />
      </Helmet>

      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        
        <main className="flex-1 container mx-auto px-4 pt-32 pb-24 max-w-3xl">
          <h1 className="text-4xl font-bold mb-6">About MacroVault</h1>
          
          <div className="space-y-6 text-foreground/80 leading-relaxed">
            <p>
              MacroVault is your go-to hub for discovering, sharing, and installing Excel VBA macros. 
              We believe automation should be accessible to everyone, not just developers.
            </p>
            
            <p>
              Our community-driven platform makes it easy to find trusted macros for everyday tasks—from 
              data cleanup and formatting to reporting and workflow automation. No coding experience required.
            </p>
            
            <p>
              Built by Excel users, for Excel users. We're on a mission to save you time and make 
              spreadsheet work more efficient.
            </p>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default About;
